import React, { useEffect, useState } from 'react';
import useManageAttachment from '../DraftManuals/_data_sources/useManageAttachment';

export interface PolicyMediaProps {
  mediaKey: string;
  manualId?: string;
  alt?: string;
  width?: string;
  height?: string;
}

export default function PolicyMedia({ mediaKey, manualId, alt, width, height }: PolicyMediaProps): JSX.Element {
  const { getAttachment } = useManageAttachment();
  const [url, setUrl] = useState<string | null>(null);
  async function refresh() {
    if (mediaKey !== undefined) {
      try {
        const attachment = await getAttachment({ manualId: manualId || '', attachmentId: mediaKey });
        setUrl(attachment.url);
      } catch (error) {
        console.error('Failed to refresh media URL:', error);
      }
    }
  }

  useEffect(() => {
    refresh();
  }, [mediaKey, manualId]);

  if (!url) {
    return <span style={{ textAlign: 'center' }}>Loading image…</span>;
  }
  return (
    <img
      src={url}
      alt={alt || 'Image'}
      style={{
        width: width || 'auto',
        height: height || 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
      }}
    />
  );
}
